import { query } from "./strapi";

/**
 * Update all cart groups with a new destination zone in a single API call
 * This prevents race conditions and reduces network traffic
 *
 * @param cartId - The ID of the cart containing groups to update
 * @param groupIds - Array of group IDs to update
 * @param destinationZoneId - The new destination zone ID to apply to all groups
 * @returns Promise with the updated cart containing recalculated fees
 */
export async function updateGroupLocation(
  cartId: string,
  groupIds: string[],
  destinationZoneId: string
) {
  const requestId = `loc-${Date.now()}`;
  console.log(
    `🔍 [${requestId}] updateGroupLocation STARTED - cartId=${cartId}`
  );

  if (!cartId) {
    throw new Error("cartId is required");
  }

  if (!groupIds || !groupIds.length) {
    throw new Error("groupIds array is required and must not be empty");
  }

  if (!destinationZoneId) {
    throw new Error("destinationZoneId is required");
  }

  try {
    // Structure the payload according to the required format
    const payload = {
      groupIds,
      destinationZoneId,
    };

    console.log(`🔄 [${requestId}] Updating groups ${payload}`);

    console.log(
      `🌍 [${requestId}] Updating ${groupIds.length} groups in cart ${cartId} with new destination: ${destinationZoneId}`,
      payload
    );

    // Fix: Change the endpoint URL format - this was causing the "invalid input syntax" error
    // The correct endpoint is "cart-groups/update-destination" without IDs in the path
    const response = await query("cart-groups/update-destination", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "x-cart-id": cartId, // Include the cart ID in headers as required
      },
      credentials: "include", // Include cookies for session authentication
      body: JSON.stringify(payload),
    });

    console.log(
      `✅ [${requestId}] updateGroupLocation SUCCESS - response received`
    );

    // Log the updated cart data with delivery fees
    if (response?.cart?.groups) {
      console.log(`💰 [${requestId}] Updated delivery fees:`, {
        groups: response.cart.groups.map((group: any) => ({
          id: group.id,
          fee: group.deliveryFee,
          weight: group.totalWeight,
        })),
        cartVersion: response.cartVersion,
        timestamp: new Date().toISOString(),
      });
    }

    return response;
  } catch (error) {
    console.error(`❌ [${requestId}] Error updating group locations:`, error);
    throw error;
  }
}
